import { AttestationSummary } from '@/typings';
import { adaptDecimalValueToPercentage } from '../utilities';
import { GetSummaryResponseDTO } from '@/api/attestation/DTOs';

export const adaptGetSummaryResponseToAttestationSummary = (
  attestationSummaryResponse: GetSummaryResponseDTO['attestation'],
): AttestationSummary => {
  return {
    fieldsCount: attestationSummaryResponse.fieldsCount,
    pendingFieldsCount: attestationSummaryResponse.pendingFieldsCount,
    requiredFieldsCount: attestationSummaryResponse.requiredFieldsCount,
    pendingRequiredFieldsCount:
      attestationSummaryResponse.pendingRequiredFieldsCount,
    restrictionViolationsCount:
      attestationSummaryResponse.restrictionViolationsCount,
    completedPercentage: adaptDecimalValueToPercentage(
      attestationSummaryResponse.completedPercentage,
    ),
  };
};
